import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { ButtonModule } from '../../../button/button.module';
import { DropZoneModule } from '../../../drop-zone/drop-zone.module';
import { InputBoxModule } from '../../../input-box/input-box.module';
import { ScrollViewModule } from '../../../scroll-view/scroll-view.module';
import { SelectBoxModule } from '../../../select-box/select-box.module';
import { TabsModule } from '../../../tabs/tabs.module';
import { AddLayersFormComponent } from './add-layers-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    InputBoxModule,
    SelectBoxModule,
    TabsModule,
    DropZoneModule,
    ScrollViewModule,
    BlockModalDragModule,
  ],
  declarations: [AddLayersFormComponent],
  exports: [AddLayersFormComponent],
})
export class AddLayersFormModule {}
